import { defineStore } from 'pinia'
import cookie from 'js-cookie'
import { getUserInfo, logout,getPartner } from '~/apis/base'
import { getTopDomainByUrl } from '~/utils/tools'

export const useUserStore = defineStore('user', {
  state: () => ({
    token: null,
    info: {},
    cache: null,
    modal: {
      kyc: false,
    },
    isPartner:false,
  }),
  getters: {
    isLogin: s => !!s.token,
    noAuth() {
      return !this.authLevel1 && !this.authLevel2
    },
    authLevel1: s => +s.info.simpleStatus === 1,
    authLevel2: s => +s.info.superStatus === 1,
    // Factor Authentication 是否开启
    fasOpen() {
      const { phoneAuthStatus, emailAuthStatus, googleAuthenticatorStatus } = this.info
      return {
        email: emailAuthStatus === 1,
        sms: phoneAuthStatus === 1,
        ga: googleAuthenticatorStatus === 1,
      }
    },
    getFaOpenByType() {
      return type => this.fasOpen[type]
    },
  },
  actions: {
    syncCookieToken(token) {
      this.token = token || localStorage.token || cookie.get('exch-token')
    },
    async getUserInfo() {
      const { success, data } = await getUserInfo()
      if (success) {
        this.info = {
          ...data,
          headerName: data.userName || data.phone || data.email,
        }
      }
    },
    async getPartner() {
      const { success, data } = await getPartner()
      if (success) {
        this.isPartner = data.isPartner
      }
    },
    async logout() {
      const { success } = await logout()

      if (!success) {
        return
      }
      cookie.remove('partner-token', {
        domain: getTopDomainByUrl(),
      })
      cookie.remove('exch-token', {
        domain: `.${getDomain()}`,
      })
      localStorage.token = ''
      this.token = null
      // location.reload()
    },
  },
})
